import type {
    ReservationCheckInStatus,
    ResourceReservationId,
} from "@towni/common";
import type {
    TanstackQueryOptions,
    TanstackSuspenseQueryOptions,
} from "../hooks/use-tanstack-query";
import {
    useTanstackSingleQuery,
    useTanstackSingleSuspenseQuery,
} from "../hooks/use-tanstack-query";

const useReservationCheckInStatusQuery = (
    resourceReservationId: ResourceReservationId | undefined,
    options: TanstackQueryOptions<ReservationCheckInStatus> = {},
) => {
    return useTanstackSingleQuery<ReservationCheckInStatus>(
        `/reservations/check-ins/${resourceReservationId}/status`,
        ["check-in-statuses", "resource-reservation", resourceReservationId],
        {
            enabled: !!resourceReservationId,
            ...options,
        },
    );
};

const useReservationCheckInStatusSuspenseQuery = (
    resourceReservationId: ResourceReservationId | undefined,
    options: TanstackSuspenseQueryOptions<ReservationCheckInStatus> = {},
) => {
    return useTanstackSingleSuspenseQuery<ReservationCheckInStatus>(
        `/reservations/check-ins/${resourceReservationId}/status`,
        ["check-in-statuses", "resource-reservation", resourceReservationId],
        {
            disabled: !resourceReservationId,
            ...options,
        },
    );
};

export {
    useReservationCheckInStatusQuery,
    useReservationCheckInStatusSuspenseQuery,
};
